import { MAP_TYPES } from '@deck.gl/carto';

const STATE_VISUALIZATIONS_SOURCE_ID = 'stateVisualizationsSource';

function source(socioeconomicFactor, stateName, property = 'year') {
  let data = '';

  if (property === 'year') {
    data = `
    SELECT
        year,
        ${socioeconomicFactor},
        broadband
      FROM
        carto-dw-ac-cn5bemsi.shared.state_observations
      WHERE
        StateName = (
          SELECT
            name
          FROM
            carto-dw-ac-cn5bemsi.shared.state_geometries
          WHERE
            STARTS_WITH(name, "${stateName}")
        )
      ORDER BY
        year
  `;
  }

  // if (property === 'broadband') {
  //   data = `
  //     WITH RankedData AS (
  //       SELECT
  //           broadband,
  //           ${socioeconomicFactor},
  //           ROW_NUMBER() OVER (PARTITION BY CAST(broadband AS INTEGER) ORDER BY year DESC) AS RowNum
  //       FROM
  //         carto-dw-ac-cn5bemsi.shared.tract_observations
  //       WHERE
  //         geoid = (
  //           SELECT
  //             geoid
  //           FROM
  //             carto-dw-ac-cn5bemsi.shared.tracts
  //           WHERE
  //           tractcode = ${stateName}
  //         )
  //       )
  //     SELECT
  //       broadband,
  //       ${socioeconomicFactor}
  //     FROM
  //       RankedData
  //     WHERE
  //       RowNum = 1
  //     ORDER BY
  //       broadband,
  //       ${socioeconomicFactor} ASC
  //   `;
  // }

  return {
    id: STATE_VISUALIZATIONS_SOURCE_ID,
    type: MAP_TYPES.QUERY,
    connection: 'carto_dw',
    data,
    queryParameters: {
      socioeconomicFactor,
      stateName,
      property,
    },
  };
}

export default source;
